<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-2">
      <div class="col">
        Content<hr>
        <ul>
          <li>MOTs Due (list)</li>
          <li>Inspections Due (list)</li>
          <li>Vehicle Availability Status</li>
          <li>% Daily Checks</li>
          <li>other stuff?</li>
        </ul>
      </div>
    </div>
  </div>  
</div>
